import React from 'react';

export default function Footer() {
  return (
<footer className="bg-primary text-white py-8">
  <div className="pt-2 flex flex-col items-center justify-center text-center">
    <p>© 2025 Pexcel Solutions Limited. All rights reserved.</p>
  </div>
</footer>

 );
}
